<h2 mat-dialog-title>{{data.message}}</h2>

<mat-dialog-content></mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button class="btn-popup" [mat-dialog-close]="false" color="accent">Nie</button>
  <button mat-raised-button class="btn-popup" [mat-dialog-close]="true" color="primary">Tak</button>
</mat-dialog-actions>
